import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCirclePast({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M7.09 3.55a.3.3 0 01.37 0l2.36 1.5a6.3 6.3 0 00-4.8 7.39h-2.3a.39.39 0 01-.39-.4V6.62zM7.56.07L9.5 1.32V.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v2.1l2.85 1.84c.24.15.3.46.15.7l-.43.67a.5.5 0 01-.7.15L7.57 2.2a.5.5 0 00-.54 0L1.19 5.96A.5.5 0 01.5 5.8l-.43-.68a.5.5 0 01.15-.69L7.02.07a.5.5 0 01.54 0zM11.2 6.4a4.8 4.8 0 110 9.6 4.8 4.8 0 010-9.6zm.85 2.53a.64.64 0 00-.84.95l.66.68H9.05l-.09.01a.64.64 0 00.09 1.26h2.82l-.67.7-.06.07a.64.64 0 00.97.81l1.72-1.77.04-.05.02-.04.05-.08a.64.64 0 00.05-.37l-.02-.09-.03-.08-.01-.03-.03-.05-.03-.04-.05-.05-1.7-1.77z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCirclePast.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCirclePast.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicCirclePast svgRef={ref} {...props} />);
export default ForwardRef;
